export const LK_GOSUSLUGI_ROLES = 'https://lk.gosuslugi.ru/roles';
